import React, { useState } from "react";
import BackDrop from "../../../components/ui/BackDrop";
import { closeIcon, addIcon } from "../../../assetData/icons";
import ManageMenuTable from "./ManageMenuTable";
import { useFieldArray, useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const ManageMenuSubmenu = ({
  tableData,
  onClose,
  buttonConfig,
  filterData,
  setSelectedId,
  setIsDelete,
  isButtonClicked,
}) => {
  const [selectedItemId, setSelectedItemId] = React.useState();
  const addHandler = buttonConfig.addManageMenu;
  const editHandler = buttonConfig.editManageMenu;

  const [scrollDown, setScrollDown] = React.useState(0);

  const schema = z.object({
    menu_id: z.number().optional(),
    menu_name: z.string().optional(),
    submenu_id: z.number().optional(),
    submenu_sortorder: z.number().optional(),
    submenu_name: z.string().optional(),
    url: z.string().optional(),
    action_pages: z.string().optional(),
    role: z.number().optional(),
  });

  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      rows: tableData || [],
    },
  });

  const { fields, append } = useFieldArray({
    control: form.control,
    name: "rows",
  });

  const rowAdding = () => {
    setScrollDown((prev) => prev + 1);
    append({
      menu_id: null,
      menu_name: "",
      submenu_id: null,
      submenu_sortorder: null,
      submenu_name: "",
      url: "",
      action_pages: "",
      role_id: filterData,
    });
  };

  const [changes, setChanges] = useState([]);

  const handleChange = (e, key, id) => {
    if (selectedItemId === 0 || selectedItemId !== null) {
      const value = e.target.value;
      setChanges((prevChanges) => {
        const existingChange = prevChanges.find((change) => change.id === id);
        if (existingChange) {
          return prevChanges.map((change) =>
            change.id === id ? { ...change, [key]: value } : change,
          );
        } else {
          return [...prevChanges, { id, [key]: value }];
        }
      });
    }
  };

  const onSubmit = async () => {
    const oldData = tableData || [];
    const newData = form.getValues().rows || [];
    const oldDataIds = new Set(oldData.map((item) => item.id));
    const newItemData = newData.filter((item) => !oldDataIds.has(item.id));
    const checkId = changes?.filter((item) => item.id);
    if (checkId && checkId.length > 0) {
      const res = await editHandler(checkId);
      setChanges([]);
      onClose();
    }

    if (newItemData && newItemData.length > 0) {
      const res = await addHandler(newItemData);
      // form.reset();
      onClose();
    }
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "menu_id",
        header: () => (
          <span className="flex w-[36px]  justify-center ">ID</span>
        ),
        cell: (info) => (
          <span className="flex w-[30px] justify-center px-1">
            {info.getValue() ? (
              form.getValues(`[rows.${info.row.index}].menu_id`)
            ) : (
              <input
                className="w-[30px] bg-white text-center focus:outline-none"
                {...form.register(`[rows.${info.row.index}].menu_id`)}
                type="number"
              />
            )}
          </span>
        ),
      },
      {
        accessorKey: "menu_name",
        header: () => (
          <span className="flex w-[206px] justify-start  px-2">Main Menu</span>
        ),
        cell: (info) => (
          <span className=" flex w-[200px] justify-start px-1">
            {info.getValue() ? (
              form.getValues(`[rows.${info.row.index}].menu_name`)
            ) : (
              <input
                className="w-[200px] bg-white  text-left focus:outline-none"
                {...form.register(`[rows.${info.row.index}].menu_name`)}
              />
            )}
          </span>
        ),
      },
      {
        accessorKey: "submenu_id",
        header: () => (
          <span className="flex w-[36px] justify-center px-1">ID</span>
        ),
        cell: (info) => (
          <span className=" flex w-[25px] justify-center px-1">
            {" "}
            {info.getValue() ? (
              form.getValues(`[rows.${info.row.index}].submenu_id`)
            ) : (
              <input
                className=" w-[25px] bg-white  text-center focus:outline-none"
                {...form.register(`[rows.${info.row.index}].submenu_id`)}
                type="number"
              />
            )}
          </span>
        ),
      },
      {
        accessorKey: "submenu_name",
        header: () => (
          <span className="flex w-[206px] justify-start px-2">Sub Menu</span>
        ),
        cell: (info) => (
          <span className=" flex w-[200px] justify-start px-1">
            {info.getValue() ? (
              form.getValues(`[rows.${info.row.index}].submenu_name`)
            ) : (
              <input
                className="w-[200px] bg-white  text-left focus:outline-none"
                {...form.register(`[rows.${info.row.index}].submenu_name`)}
              />
            )}
          </span>
        ),
      },
      {
        accessorKey: "submenu_sortorder",
        header: () => (
          <span className="flex w-[96px] justify-center px-1">Sort Order</span>
        ),
        cell: (info) => (
          <span className=" flex w-[90px] justify-center px-1">
            {selectedItemId === info.row.index || !info.getValue() ? (
              <input
                className="w-full bg-white  text-center focus:outline-none"
                {...form.register(`[rows.${info.row.index}].submenu_sortorder`)}
                type="number"
                onChange={(e) =>
                  handleChange(
                    e,
                    "submenu_sortorder",
                    form.getValues(`[rows.${info.row.index}].id`),
                  )
                }
              />
            ) : (
              form.getValues(`[rows.${info.row.index}].submenu_sortorder`)
            )}
          </span>
        ),
      },
      {
        accessorKey: "action_pages",
        header: () => (
          <span className="flex  w-[206px] justify-start px-2">
            Action Pages
          </span>
        ),
        cell: (info) => (
          <span className=" flex w-[200px] justify-start px-1">
            {selectedItemId === info.row.index || !info.getValue() ? (
              <input
                disabled={form.getValues(`[rows.${info.row.index}].url`)}
                className="w-full bg-white  focus:outline-none"
                {...form.register(`[rows.${info.row.index}].action_pages`)}
                onChange={(e) =>
                  handleChange(
                    e,
                    "action_pages",
                    form.getValues(`[rows.${info.row.index}].id`),
                  )
                }
              />
            ) : (
              form.getValues(`[rows.${info.row.index}].action_pages`)
            )}
          </span>
        ),
      },
      {
        accessorKey: "url",
        header: () => (
          <span className="flex w-[225px] justify-start px-2">URL</span>
        ),
        cell: (info) => (
          <span className=" flex w-[217px] justify-start px-1">
            {selectedItemId === info.row.index || !info.getValue() ? (
              <input
                disabled={form.getValues(
                  `[rows.${info.row.index}].action_pages`,
                )}
                className="w-full bg-white  focus:outline-none"
                {...form.register(`[rows.${info.row.index}].url`)}
                onChange={(e) =>
                  handleChange(
                    e,
                    "url",
                    form.getValues(`[rows.${info.row.index}].id`),
                  )
                }
              />
            ) : (
              form.getValues(`[rows.${info.row.index}].url`)
            )}
          </span>
        ),
      },
      {
        accessorKey: "status",
        header: () => (
          <span className="flex w-[80px] justify-center px-1">Status</span>
        ),
        cell: (info) => (
          <span className=" flex w-[80px] justify-center px-1">
            {info.getValue() ? "Active" : "Inactive"}
          </span>
        ),
      },
      {
        accessorKey: "icons",
        header: () => (
          <span className="flex w-[100px] justify-center px-1">Action</span>
        ),
        cell: (info) => (
          <span className=" flex w-[93px] justify-center px-1">
            {info.getValue()}
          </span>
        ),
      },
    ],
    [form, selectedItemId],
  );
  return (
    <>
      <div className="fixed left-1/2 top-1/2 z-50 mx-auto min-h-[300px] w-full max-w-[1290px] -translate-x-1/2 -translate-y-1/2 rounded bg-white p-8">
        <h2 className=" text-2xl font-bold text-neutral-800">
          Manage Menu & Sub Menu
        </h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} alt="close icon" />
        </button>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <ManageMenuTable
            columns={columns}
            tableData={form.getValues().rows}
            setSelectedItemId={setSelectedItemId}
            setSelectedId={setSelectedId}
            setIsDelete={setIsDelete}
            buttonConfig={buttonConfig}
            filterData={filterData}
            onClose={onClose}
            scrollDown={scrollDown}
          />
          <div className="mt-4 flex gap-4 text-[#428DCB]">
            <img
              src={addIcon}
              alt=""
              onClick={() => rowAdding()}
              className="cursor-pointer"
            />
            <h2 onClick={() => rowAdding()} className="cursor-pointer">
              ADD MENU-SUBMENU
            </h2>
          </div>

          {/* action */}
          <div className="flex w-[200px]  items-end gap-4">
            <button
              type="submit"
              disabled={isButtonClicked?.subMenu}
              className={` ${
                isButtonClicked?.subMenu ? "opacity-[70%]" : ""
              } mt-4 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange  py-1 font-semibold text-white `}
            >
              {isButtonClicked?.subMenu ? <MirageLoader /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
      <BackDrop closeHandler={onClose} />
    </>
  );
};

export default ManageMenuSubmenu;
